<template>
  <div>
    <div class="banner">
      <h2>{{ $t('pricing1') }}</h2>
      <p
        data-aos="fade-right"
        data-aos-offset="140"
        data-aos-easing="ease-in-sine"
      >
        {{ $t('pricing2') }}
      </p>
      <p
        data-aos="fade-right"
        data-aos-offset="140"
        data-aos-easing="ease-in-sine"
      >
        {{ $t('pricing3') }}
      </p>
      <p
        data-aos="fade-right"
        data-aos-offset="140"
        data-aos-easing="ease-in-sine"
      >
        {{ $t('pricing4') }}
      </p>
    </div>
    <div id="pricing" class="banner mg-t">
      <h2>{{ $t('choosePlan') }}</h2>
      <!-- <h2>{{ $t('startOne') }}</h2> -->
    </div>
    <div class="choiceContainer">
      <div class="choice">
        <span class="choiceTitle">1. {{ $t('unitCount') }}</span>
        <!-- <span class="choiceTitle">{{ $t('startOneDisclaimer') }}</span> -->
        <br />
        <div class="countButtons">
          <button
            v-on:click="decrement"
            data-qa="removeUnitButton"
            class="button"
          >
            -
          </button>
          <span class="unitNo">{{ unitCount }}</span>
          <button
            v-on:click="increment"
            data-qa="addUnitButton"
            class="button"
          >
            +
          </button>
        </div>
      </div>
      <!-- <div class="choice">
                <span class="choiceTitle">2. {{ $t('PlanPicker') }}</span>
                <ToggleAnim v-model="subscriptionPlan" @plan-changed="selectedPlan = planDetails[subscriptionPlan]"/>
            </div>
            <div class="choice">
                <span class="choiceTitle">3. {{ $t('CurrencyPicker') }}</span>
                <div class="currencyPicker">
                    <select class="selectCurrency" v-model="selectedCurrency">
                        <option data-qa="euroCurrencyButton" v-bind:key="index" v-for="(currency, index) in currencies" v-bind:value="currency.name"> {{ currency.name }} </option>
                    </select>
                </div>
            </div> -->
    </div>
    <div class="card-deck mb-3 ml-3 mr-3 text-center" v-if="selectedPlan">
      <div class="card mb-8 box-shadow" data-aos="fade-up">
        <div class="card-header">
          <span class="totalPrice"
            >{{ ((selectedPlan.price / 100) * unitCount).toFixed(0) }}
            {{ selectedCurrency }}</span
          ><span class="unit"
            >/ {{ subscriptionPlan === 'month' ? $t('month') : $t('year') }}</span
          >
          <!-- <p>{{ $t('with') }} {{ subscriptionPlan === 'month' ? 'mesečnimi' : 'letnim' }} {{ $tc('payment', 2) }}</p> -->
        </div>
        <div class="card-body">
          <br />
          <p class="card-title">{{ $t('PackageIncludes') }}:</p>
          <ul class="list-unstyled mt-3 mb-4 package">
            <li>
              &#10004;<span> {{ $t('unitNo') }}: {{ unitCount }} </span>
            </li>
            <li>
              &#10004;<span>
                {{ maxDataStorage * unitCount }} MB {{ $t('package3') }}</span
              >
            </li>
            <li>
              &#10004;<span> {{ $t('package4') }}</span>
            </li>
            <li>
              &#10004;<span> {{ $t('package5') }}</span>
            </li>
            <li>
              &#10004;<span> {{ $t('package6') }}</span>
            </li>
            <li>
              &#10004;<span> {{ $t('package7') }}</span>
            </li>
            <li>
              &#10004;<span> 2 {{ $t('package1') }}</span>
            </li>
            <li>
              &#10004;<span> {{ $t('package2') }}</span>
            </li>
            <li class="inactiveSoon">
              <span> {{ $t('package8') }}</span>
              <span class="soon">{{ $t('soon') }}</span>
            </li>
            <li class="inactiveSoon">
              <span> {{ $t('package9') }}</span>
              <span class="soon">{{ $t('soon') }}</span>
            </li>
          </ul>
          <hr />
          <button
            type="button"
            data-qa="freeTrialSubscrButton"
            class="btn btn-lg btn-outline-primary btn-monthly"
            @click="
              sendSubscriptionDetails()
              $bvModal.show('register-modal')
            "
          >
            30-{{ $t('daysfreeTrial') }}
          </button>
          <br />
          <div class="disclaimer">
            <p>{{ $t('VATdisclaimer') }}</p>
          </div>
        </div>
        <div class="discount">
          <p>
            {{ $t('DiscountDisclaimer') }}
            <a class="quote" href="mailto:inquiry@expar-store.com">{{
              $t('quote')
            }}</a
            >.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import ToggleAnim from '../common/ToggleAnim.vue'

export default {
  components: {
    // ToggleAnim
  },
  data() {
    return {
      value: '',
      unitCount: 1,
      maxDataStorage: 50,
      totalPrice: 7,
      subscriptionPlan: 'month',
      selectedCurrency: '€',
      currencies: [
        {
          name: '€',
          rate: 1,
        },
        // {
        //     name: "$",
        //     rate: 1.21,
        // },
        // {
        // 	name: "£",
        //     rate: 0.89,
        // },
      ],
      planDetails: {},
      selectedPlan: null,
    }
  },
  methods: {
    increment() {
      this.unitCount += 1
    },
    decrement() {
      if (this.unitCount === 1) return
      this.unitCount -= 1
    },
    sendSubscriptionDetails() {
      this.$emit('subscription-data', {
        amount: (this.selectedPlan.price / 100) * this.unitCount,
        unit_count: this.unitCount,
        currency: 'eur',
        subscription_plan:
          this.subscriptionPlan === 'month' ? 'monthly' : 'yearly',
        price_id: this.selectedPlan.id,
        storage_value: this.maxDataStorage * this.unitCount,
        storage_unit: 'MB',
        status: 'trial',
      })
    },
  },
  async mounted() {
    const planList = await this.$store.dispatch('fetchSubscriptionPlanDetails')
    const filteredPlan = planList.filter(plan => {
      return plan.nickname === 'freemium'
    })
    this.selectedPlan = filteredPlan[0]
  },
}
</script>

<style lang="css" scoped>
.selectCurrency {
  font-size: 2.1em;
  font-weight: 600;
  color: var(--bg);
}
.currencyPicker {
  padding: 10px;
}
.banner h2 {
  font-size: 3em;
  font-weight: 600;
  margin-bottom: 1em;
}

.inactiveSoon {
  color: var(--grey-light);
}
.soon {
  text-transform: uppercase;
  letter-spacing: 4px;
  margin-left: 20px;
}
.banner p {
  color: var(--gray);
  font-size: 2em;
  font-weight: 400;
  padding: 0.4em;
}

.discount p {
  color: var(--gray);
  font-size: 1.4em;
  font-weight: 300;
  padding: 0.6em;
  text-align: justify;
}

.disclaimer p {
  color: var(--bright);
  font-size: 1em;
  font-weight: 100;
  padding: 0.2em;
}
.quote {
  color: var(--bg) !important;
  font-weight: 600;
}
.quote:active {
  color: var(--primary) !important;
  text-decoration: none;
}
.quote:hover {
  color: var(--primary) !important;
  text-decoration: none;
}

.mg-t {
  margin-top: 7em;
}

button:disabled,
button[disabled] {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}

.button {
  padding: 0px 20px;
  margin: 5px 30px;
  font-size: 35px;
  font-weight: 500;
  text-align: center;
  cursor: pointer;
  outline: none;
  color: var(--bg);
  background-color: var(--grey);
  border-radius: 50%;
  box-shadow: 0px 1px 5px var(--bg-superLight);
}

.unitNo {
  font-size: 3.5em;
  font-weight: 600;
  color: var(--bg);
}
.totalPrice {
  font-size: 4em;
  font-weight: 400;
  margin: 0.3em;
}
.unit {
  font-size: 1.5em;
  font-weight: 400;
}
.choiceTitle {
  font-size: 2em;
}
.countButtons {
  margin-top: 2.3em;
}
.card-title {
  color: var(--bright);
  font-size: 1.5em;
  width: 300px;
}

.button:active {
  background-color: var(--primaryLight);
  box-shadow: 1px 3px 20px var(--primaryLight);
  transform: translateY(2px);
  font-weight: 800;
  border: none;
}
/* @media all and (max-width:30em){
    button{
    display:block;
    margin:0.4em auto;
    }
} */

.choiceContainer {
  display: flex;
  margin: 4em 2em 2em 2em;
}

.choice {
  flex: 1; /*grow*/
  margin-bottom: 2em;
}

@media (max-width: 768px) {
  /*breakpoint*/
  .choiceContainer {
    flex-direction: column;
    margin: 0em 2em 2em 2em;
  }
  .mg-t {
    margin-top: 0em;
  }
}
.card {
  margin: 0 27%;
}

.card-header {
  background-color: rgba(0, 0, 0, 0.12);
}

.card-body {
  background: var(--bg-superLight);
}

.card-body p {
  color: var(--bright);
}

.btn-monthly {
  background: var(--primary);
  border: none;
  font-size: 2em;
  padding: 10px;
  text-transform: uppercase;
  color: var(--bright);
}

.btn-monthly:hover {
  color: var(--primary);
  background: var(--bg);
}

.btn-yearly {
  background: rgba(185, 123, 66, 0.4);
  border: var(--primary);
  padding: 10px;
  color: var(--bg-light);
}

.btn-yearly:hover {
  color: var(--bright);
  background: var(--primary);
}

.package {
  text-align: left;
  padding: 1px;
  margin-left: 30px;
  color: var(--bright);
}
.package li {
  padding: 7px;
}
.box-shadow {
  box-shadow: 0px 1px 5px var(--bg-superLight);
}

@media (min-width: 768px) {
  .card-deck .card {
    min-width: 220px;
  }
}

@media (max-width: 500px) {
  .card {
    margin: 0 2%;
  }
  .banner {
    padding: 2em;
  }
  .banner h2 {
    font-size: 2em;
  }
  .banner p {
    font-size: 1.4em;
    text-align: left;
    padding: 0.2em;
  }
  .button {
    margin: 5px 20px;
    font-size: 30px;
  }
  .totalPrice {
    font-size: 3em;
  }
  .btn-monthly {
    font-size: 1.4em;
  }
  .card-body {
    padding: 0;
  }
  .btn-monthly {
    margin: 0 10px;
  }
}
/* SMARTPHONES LANDSCAPE */
@media only screen and (min-device-width: 480px) and (max-device-width: 820px) and (orientation: landscape) {
  .card {
    margin: 0 17%;
  }
  .choiceTitle {
    font-size: 1.6em;
  }
  .countButtons button {
    margin: 5px 20px;
  }
  .pricing-switcher .fieldset {
    margin-top: 3.3em;
  }
  .currencyPicker {
    margin-top: 2.8em;
  }
}

/*iPad */
@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait) {
  .card {
    max-width: 500px;
    margin: auto;
  }
}

@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
  .card {
    max-width: 650px;
    margin: auto;
  }
  .package li {
    padding: 1px;
  }
}
/*iPhone 6/7/8/X/11Pro/12 Mini */
@media only screen and (min-device-width: 375px) and (max-device-width: 389px) and (orientation: portrait) {
  .package li {
    padding: 3px;
  }
}
/*Galaxy S5/S8/Moto S4  and Note 3*/
@media only screen and (min-device-width: 360px) and (max-device-width: 374px) and (orientation: portrait) {
  .package li {
    padding: 5px;
  }
}
/*iPhone 5 */
@media only screen and (min-device-width: 320px) and (max-device-width: 359px) and (orientation: portrait) {
  .package li {
    padding: 3px;
  }
}
</style>